import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';
import {
  errorsReducer,
  queriesReducer,
} from 'redux-query';

import entitiesReducer from './queries/reducers/entities';
import serviceConfig from './services/reducer';

const createGlobalReducer = (history) => (
  combineReducers({
    entities: entitiesReducer,
    errors: errorsReducer,
    queries: queriesReducer,
    router: connectRouter(history),
    serviceConfig,
  })
);

export default createGlobalReducer;
